<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"/>

    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="客户姓名">
          <el-input
            placeholder="请输入客户姓名"
            v-model="searchData.memberName"
            clearable
            size="small"
            style="width: 180px"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            placeholder="请输入手机号"
            v-model="searchData.mobile"
            clearable
            size="small"
            style="width: 180px"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            placeholder="请输入订单号"
            v-model="searchData.orderNo"
            clearable
            size="small"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="挂账变动类型">
          <el-select
            v-model="searchData.reserveType"
            placeholder="请选择"
            clearable
            size="small"
          >
            <el-option
              v-for="item in reserveTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变动时间">
          <el-date-picker
            v-model="searchData.timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 300px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="售后状态" class="bill-type">
          <SelectDict
              v-model="searchData.afterSaleStatusList"
              multiple
              dictCode="order:afterSaleStatus"
              style="width: 200px"
          ></SelectDict>
        </el-form-item>
        <el-form-item label=" ">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="search"
            >搜索</el-button
          >
          <el-button
            type="info"
            size="small"
            icon="el-icon-refresh"
            @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>

    <div class="header-btn">
      <el-button
          v-checkbtn="isShowBtn(AUTH_BTN.finance_reserve_list_add)"
          style="margin-left:20px"
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="onReserveAdd"
      >
        新增
      </el-button>

      <el-button
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="exportData"
        :disabled="!isShowBtn(AUTH_BTN.finance_reserve_list_export)"
      >
        导出
      </el-button>
    </div>

    <tp-table
      :isNeedSerialNumber="true"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
      empty-text="暂无挂账记录"
    />

    <el-dialog title="新增挂账" :visible.sync="visible" width="600px">
      <el-form
        :model="reserveFormData"
        class="reserve-add-box"
        ref="addForm"
        label-width="140px"
      >
        <el-form-item label="订单号">
          <div style="display: flex; flex-direction: row;">
            <el-input
              v-model="reserveFormData.orderNo"
              placeholder="请输入订单号"
              size="small"
              style="width: 250px"
            />
            <div style="margin-left: 10px;">
              <el-button type="primary" size="small" @click="handleOrderNoConfirm">确 认</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="客户姓名" v-if="reserveFormData.orderInfo">
          {{ reserveFormData.orderInfo.member ? reserveFormData.orderInfo.member.memberName : "" }}
        </el-form-item>
        <el-form-item label="手机号" v-if="reserveFormData.orderInfo">
          {{ reserveFormData.orderInfo.member ? reserveFormData.orderInfo.member.mobile : "" }}
        </el-form-item>
        <el-form-item label="挂账余额" v-if="reserveFormData.orderInfo">
          {{ reserveFormData.orderInfo.reserveAmount || "" }}
        </el-form-item>
        <el-form-item label="挂账变动类型" v-if="reserveFormData.orderInfo">
          减少挂账
        </el-form-item>
        <el-form-item label="本次调整金额" v-if="reserveFormData.orderInfo">
          <el-input
            placeholder="请输入本次调整金额"
            size="small"
            style="width: 250px"
            v-model="reserveFormData.amount"
          />
        </el-form-item>
        <el-form-item label="备注" v-if="reserveFormData.orderInfo">
          <el-input
            v-model="reserveFormData.remark"
            type="textarea"
            placeholder="请输入备注"
            rows="5"
            maxlength="200"
            style="width: 350px"
          />
        </el-form-item>
        <el-form-item label="" label-width="0">
          <div style="text-align: center; padding-top: 20px">
            <el-button
              type="primary"
              size="small"
              :disabled="!reserveFormData.orderInfo"
              @click="handleAddReserve"
            >
              保 存
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { getReserveListAPI, exportReserveAPI, getOrderInfoAPI, addReserveAPI } from "./api";
import SelectDict from "@/views/components/select-dict.vue";

// 表格列配置
const columns = [
  {
    label: "用户信息",
    prop: "member",
    minWidth: 150,
    customRender(h, row) {
      return (
        <div>
          <p>姓名：{row["memberName"]}</p>
          <p>手机号：{row["memberMobile"]}</p>
        </div>
      );
    },
  },
  {
    label: "订单信息",
    prop: "order",
    minWidth: 240,
    customRender(h, row) {
      return (
          <div>
            <p>订单号：{row["orderNo"]}</p>
            <p>订单状态：{row["orderStatusName"]}</p>
            <p>售后状态：{row["afterSaleStatusName"]}</p>
          </div>
      );
    },
  },
  {
    label: "变动类型",
    prop: "reserveType",
    minWidth: 150,
    customRender(h, row) {
      const typeMap = {
        101: "新增挂账",
        201: "减少挂账",
        202: "线下还款抵扣",
      };
      return <p>{typeMap[row["reserveType"]] || "-"}</p>;
    },
  },
  {
    label: "变动金额",
    prop: "amount",
    minWidth: 100,
    customRender(h, row) {
      const isPositive = row["amountType"] === 1; // 新增挂账为绿色
      const amount = parseFloat(row["amount"] || 0).toFixed(2);
      return (
        <span style={`color: ${isPositive ? "#67C23A" : "#F56C6C"}; font-weight: bold;`}>
          {(isPositive ? '+' : '-') + amount}
        </span>
      );
    },
  },
  {
    label: "变动前金额",
    prop: "beforeAmount",
    minWidth: 100,
    customRender(h, row) {
      return <p>{ row["beforeAmount"] }</p>;
    },
  },
  {
    label: "变动后金额",
    prop: "afterAmount",
    minWidth: 100,
    customRender(h, row) {
      return <p>{ row["afterAmount"] }</p>;
    },
  },
  {
    label: "变动时间",
    prop: "createTime",
    minWidth: 180,
    customRender(h, row) {
      const time = row["createTime"];
      return <p>{time || "-"}</p>;
    },
  },
  {
    label: "备注",
    prop: "remark",
    minWidth: 200,
    customRender(h, row) {
      return <p>{row["remark"] || "-"}</p>;
    },
  },
  {
    label: "操作人",
    prop: "actionUserName",
    minWidth: 120,
    customRender(h, row) {
      return <p>{row["actionUserName"]}</p>;
    },
  },
];

export default {
  name: "FinanceReserveList",
  components: {SelectDict},
  mixins: [authBtnMixin],
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        memberName: "",
        mobile: "",
        orderNo: "",
        reserveType: "",
        timeRange: [],
        afterSaleStatusList: [],
      },
      // 挂账变动类型选项
      reserveTypeOptions: [
        { name: "新增挂账", value: 101 },
        { name: "减少挂账", value: 201 },
        { name: "线下还款抵扣", value: 202 },
      ],
      visible: false,
      reserveFormData: {
        orderNo: "",
        orderInfo: undefined,
        amount: "",
        remark: "",
      }
    };
  },

  mounted() {
    this.getList();
  },

  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },

  methods: {
    // 搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },

    // 获取挂账列表
    async getList() {
      try {
        let params = {
          page: this.currentPage,
          pageSize: this.pageSize,
          memberName: this.searchData.memberName,
          memberMobile: this.searchData.mobile,
          orderNo: this.searchData.orderNo,
          reserveType: this.searchData.reserveType,
          afterSaleStatusList: this.searchData.afterSaleStatusList.join(","),
        };
        // 处理时间范围
        if (this.searchData.timeRange && this.searchData.timeRange.length === 2) {
          params.leftCreateDate = this.searchData.timeRange[0];
          params.rightCreateDate = this.searchData.timeRange[1];
        }
        const res = await getReserveListAPI(params);
        this.list = res.list || [];
        this.total = res.total || 0;
      } catch (error) {
        console.error("获取挂账列表失败:", error);
        this.$message.error("获取挂账列表失败");
      }
    },

    initReserveFormData() {
      this.reserveFormData.orderNo = "";
      this.reserveFormData.orderInfo = undefined;
      this.reserveFormData.amount = "";
      this.reserveFormData.remark = "";
    },

    onReserveAdd() {
      this.initReserveFormData();
      this.visible = true;
    },

    handleOrderNoConfirm() {
      if (!this.reserveFormData.orderNo) {
        return this.$message.error("请输入订单号！");
      }
      getOrderInfoAPI({ orderNo: this.reserveFormData.orderNo })
        .then(res => {
          this.reserveFormData.orderInfo = res;
          this.reserveFormData.amount = "";
          this.reserveFormData.remark = "";
        });
    },

    handleAddReserve() {
      if (!this.reserveFormData.orderNo) {
        return this.$message.error("请输入订单号！");
      }
      if (!this.reserveFormData.amount) {
        return this.$message.error("请输入调整金额！");
      }
      if (this.reserveFormData.amount - 0 <= 0) {
        return this.$message.error("调整金额不能小于等于0！");
      }
      const params = {
        orderNo: this.reserveFormData.orderNo,
        reserveType: 201,
        amount: this.reserveFormData.amount,
        remark: this.reserveFormData.remark,
      };
      addReserveAPI(params)
        .then(_ => {
          this.initReserveFormData();
          this.visible = false;
          this.getList();
        });
    },

    // 导出数据
    exportData() {
      let data = {
        memberName: this.searchData.memberName,
        memberMobile: this.searchData.mobile,
        orderNo: this.searchData.orderNo,
        reserveType: this.searchData.reserveType,
        afterSaleStatusList: this.searchData.afterSaleStatusList,
      };
      // 处理时间范围
      if (this.searchData.timeRange && this.searchData.timeRange.length === 2) {
        data.leftCreateDate = this.searchData.timeRange[0];
        data.rightCreateDate = this.searchData.timeRange[1];
      }
      exportReserveAPI(data);
    },

    // 重置搜索条件
    reset() {
      this.searchData = {
        memberName: "",
        mobile: "",
        orderNo: "",
        reserveType: "",
        timeRange: [],
        afterSaleStatusList: [],
      };
      this.currentPage = 1;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;

  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 20px;
        margin-bottom: 10px;
        .el-input {
          width: 180px;
        }

        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }

          .el-range-input {
            width: 35%;
          }
        }
      }

      .el-select .el-input {
        width: 200px;
      }

      .input-with-select {
        vertical-align: middle;
      }

      .input-with-select .el-input-group__prepend {
        background-color: #fff;
      }

      .bill-type {
        .el-select {
          width: 200px !important;
        }
      }
    }
  }

  .el-divider--horizontal {
    margin: 0 0 20px;
  }

  .header-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }

  .reserve-add-box {
    .el-form-item {
      margin-bottom: 10px;
    }
  }
}
</style>
